<template>
  <span class="bg-warning border rounded" v-if="msg">{{ msg }}</span>
  <input
    type="text"
    class="form-control"
    v-model.trim="name"
    @keyup.enter="updateName()"
  />
</template>
<script setup>
import { onMounted, defineProps, ref, defineEmits } from "vue";
import supabase from "@/supabase/config";
const props = defineProps(["player_id"]);
const emit = defineEmits(["nameUpdated"]);
const name = ref("");
const msg = ref("");
onMounted(() => {
  setTimeout(() => {
    fetchName();
  }, 500);
});
const fetchName = async () => {
  let { data: players, error } = await supabase
    .from("players")
    .select("name")
    .eq("id", props.player_id);
  name.value = players[0].name;
};
const updateName = async () => {
  if (name.value) {
    const { data, error } = await supabase
      .from("players")
      .update({ name: name.value })
      .eq("id", props.player_id)
      .select();
    if (!error) {
      emit("nameUpdated");
    }
  } else {
    msg.value = "Cannot be blank";
    setTimeout(() => {
      msg.value = "";
    }, 2000);
  }
};
</script>
